<template>
  <div class="icons-bg">
    <section class="section-foodAndDrinks">
      <div class="container">
        <div class="section-space-50"></div>
        <div class="section-header-title">Food &amp; Beverages</div>
        <div class="section-space-25"></div>
        <div class="row">
          <div class="col-md-8">
            <p class="text-rose-gold font-weight-600 h5">
              Delivering happiness at your seat 1
            </p>
            <p>
              We deliver your orders directly to your seat during interval time
              so don’t worry about going to the counter in order to get your
              favorite snack! Lorem ipsum dolor sit amet, consectetur adipiscing
              elit, sed do eiusmod tempor incididunt ut labore et dolore magna
              aliqua
            </p>
          </div>
          <div class="col-md-4 no-fnb-box py-3 mx-2 mx-md-0">
            <p class="text-rose-gold font-weight-600 h5">
              Booked your tickets but didn’t add snacks?
            </p>
            <p>
              Fret not, you still can! Click on the link below, enter your
              ticket details, add Food &amp; Drinks to cart and pick it up from
              the counter!
            </p>
            <button
              class="btn btn-primary"
              @click="$bvModal.show('verifyBooking')"
            >
              Book food/drinks
            </button>
          </div>
        </div>

        <div class="section-space-25"></div>

        <ul class="list-inline mx-auto fnb-page-List text-center">
          <li class="list-inline-item">
            <button
              class="btn rounded-10 font-weight-600 w-100"
              :class="
                active1
                  ? 'btn-primary'
                  : 'btn-outline-primary text-dark'
              "
            >
              Combos
            </button>
          </li>

          <li class="list-inline-item">
            <button
              class="btn rounded-10 font-weight-600 w-100"
              :class="
                active2
                  ? 'btn-primary'
                  : 'btn-outline-primary text-dark'
              "
            >
              Popcorn
            </button>
          </li>
          <li class="list-inline-item">
            <button
              class="btn rounded-10 font-weight-600 w-100"
              :class="
                active3
                  ? 'btn-primary'
                  : 'btn-outline-primary text-dark'
              "
            >
              Beverages
            </button>
          </li>

          <li class="list-inline-item">
            <button
              class="btn rounded-10 font-weight-600 w-100"
              :class="
                active4
                  ? 'btn-primary'
                  : 'btn-outline-primary text-dark'
              "
            >
              Meals
            </button>
          </li>
        </ul>

        <div class="row justify-content-center">
          <div class="col-4 col-sm-3 col-md-2 col-xl-2 mb-3"></div>
          <div class="col-4 col-sm-3 col-md-2 col-xl-2 mb-3"></div>
          <div class="col-4 col-sm-3 col-md-2 col-xl-2 mb-3"></div>
          <div class="col-4 col-sm-3 col-md-2 col-xl-2 mb-3"></div>
        </div>
        <div class="section-space-25"></div>

        <div class="row">
          <div
            :key="fndKey"
            v-for="(fnd, fndKey) in items"
            class="col-12 col-md-4 col-lg-4 col-xl-4 mb-3 mb-md-5"
          >
            <div class="fnd-card">
              <div class="fnd-img">
                <div
                  :class="
                    fnd.item_category === 'V'
                      ? 'is-veg'
                      : fnd.item_category === 'N'
                      ? 'is-nonVeg'
                      : null
                  "
                ></div>
                <img
                  v-lazy="
                    fnd && fnd.image_path ? IMAGE_URL + fnd.image_path : null
                  "
                  class="img-fluid"
                  alt
                />
                <label class="fnd-label">{{ fnd.Item_strDescription }}</label>
              </div>
              <div class="fnd-card-content">
                <p class="fnd-item-description">{{ fnd.item_description }}</p>
                <strong>₹{{ fnd.Item_intPrice }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <PromotionsAndOffers /> -->

    <!-- FOOD & DRINKS - PAGE - BOOK LATER VERIFY YOUR BOOKING MODAL -->
    <b-modal
      id="verifyBooking"
      title="Verify your booking"
      class="imp-popup"
      hide-footer
    >
      <div class="p-3">
        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
          <div class="row mx-0">
            <div class="col-12 my-3 px-3 text-center">
              Enter your details below to verify your booking and then proceed
              to add Food &amp; Drinks
            </div>

            <form @submit.stop.prevent="verifyBooking">
              <div class="form-row">
                <div class="col-12 mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="BookingID"
                    placeholder="Booking ID"
                    v-model="booking_id"
                  />
                  <div class="small text-danger" v-if="invalidBookingId">
                    Please enter a valid booking ID
                  </div>
                </div>

                <!-- VUE-TEL-INPUT -->
                <!-- <div class="col-12 mb-3">
                  <vue-tel-input v-model="phone" class="pl-0 form-control"></vue-tel-input>
                  <div class="small text-danger">Test Message</div>
                </div>-->

                <!-- HIDE THIS IF USE TEL-INPUT -->
                <div class="col-12 mb-3">
                  <div class="form-row">
                    <!-- <div class="col-12">
                      <div
                        class="has-chevron"
                        :class="countryCode ? 'chevron-inverse' : ''"
                      >
                        <input
                          type="search"
                          placeholder="+ 91"
                          v-model="searchCountry"
                          v-on:blur="countryCode = !countryCode"
                          v-on:focus="countryCode = !countryCode"
                          class="form-control"
                        />
                      </div>
                      <div
                        class="select-location-box countryCode"
                        v-if="countryCode"
                      >
                        <ul class="search-result-list">
                          <li
                            v-for="(countryCode, countryCodeIndex) in 10"
                            :key="countryCodeIndex"
                          >
                            +91
                          </li>
                        </ul>
                      </div>
                    </div> -->
                    <div class="col-12">
                      <!-- <input
                        type="number"
                        class="form-control"
                        id="validationCustom02"
                        placeholder="Enter Phone number"
                        v-model="user_number"
                      /> -->
                      <input
                        type="number"
                        placeholder="+91 94348372356"
                        class="form-control"
                        id="number"
                        v-model="user_number"
                      />
                    </div>
                  </div>
                  <div class="small text-danger" v-if="invalidPhoneNumber">
                    Please enter a valid phone number
                  </div>
                </div>
                <div class="col-12 mb-3">
                  <div
                    class="has-chevron"
                    :class="movieSearch ? 'chevron-inverse' : ''"
                  >
                    <input
                      type="text"
                      placeholder="Movie Title, Time, Screen"
                      v-model="searchMovie"
                      v-on:blur="movieSearch = !movieSearch"
                      v-on:focus="movieSearch = !movieSearch"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="select-location-box countryCode"
                    v-if="movieSearch"
                  >
                    <ul class="search-result-list">
                      <li
                        v-for="(movieSearch, movieSearchIndex) in 10"
                        :key="movieSearchIndex"
                      >
                        Test
                      </li>
                    </ul>
                  </div>
                  <div class="small text-danger">Test Message</div>
                </div>

                <div class="col-12 mb-3 px-0">
                  <div class="form-row">
                    <div class="col-3">
                      <input
                        type="text"
                        placeholder="Row"
                        class="form-control"
                      />
                    </div>
                    <div class="col-3">
                      <input
                        type="text"
                        placeholder="Seat"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
                <!-- ********** -->
              </div>

              <button class="btn btn-primary w-100" type="submit">
                <!-- @click="$bvModal.show('giftSend')" -->
                VERIFY
              </button>
            </form>
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </b-modal>

    <!-- FOOD & DRINKS - PAGE - BOOK LATER GIFT SENT MODAL -->
    <b-modal
      id="giftSend"
      title="Booking Verified"
      class="imp-popup"
      hide-footer
    >
      <div class="px-3 py-4">
        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
          <div class="row">
            <div class="col-12 text-center mb-3">
              <img src="@/assets/img/icons/check-icon.svg" alt="Success" />
            </div>
            <div class="col-12 text-center">
              <p>
                Your details have been verfied! Let’s proceed to add Food &amp;
                Drinks to your cart!
              </p>
            </div>
          </div>
          <div class="row send-gift-modal my-4">
            <div class="col-3">
              <img
                v-lazy="
                  verified_movie && verified_movie.image_path_1
                    ? IMAGE_URL + verified_movie.image_path_1
                    : null
                "
                alt="Movie Banner"
                class="img-fluid"
              />
            </div>
            <div class="col-9 pl-0">
              <p class="title mb-1 text-left">
                {{ verified_movie && verified_movie.Film_strTitle }}
              </p>
              <ul class="list-inline dateTime d-none d-md-block mb-2">
                <li class="list-inline-item">
                  {{
                    verified_movie &&
                      verified_movie.Session_dtmRealShow | dateparse
                  }}
                  |
                  {{
                    verified_movie &&
                      verified_movie.Session_dtmRealShow | timeparse
                  }}
                </li>
              </ul>
              <div class="cinemaName mb-2">
                <p class="mb-0">
                  {{ verified_movie && verified_movie.Cinema_strName }}
                </p>
                <p class="mb-0">
                  {{ verified_movie && verified_movie.cinema_address }}
                </p>
              </div>

              <div class="d-flex">
                <div class="mr-1">Seats:</div>
                <ul class="list-inline mb-0 seats font-weight-bold">
                  <li class="list-inline-item mob-fs-14">
                    {{ verified_movie && verified_movie.strSeatInfo }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12">
            <button
              class="btn btn-primary w-100"
              @click="$router.push({ path: '/fnd-checkout' })"
            >
              PROCEED
            </button>
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import PromotionsAndOffers from "@/components/partials/promotionsAndOffers";
import { mapState, mapGetters, mapActions } from "vuex";
import ItemsService from "@/apiServices/ItemsService";
import TransactionService from "@/apiServices/TransactionService";
import { IMAGEURL } from "@/config";
export default {
  components: {
    PromotionsAndOffers
  },
  data() {
    return {
      IMAGE_URL: IMAGEURL,
      countryCode: false,
      searchMovie: "",
      veg: true,
      movieSearch: "",
      active1: true,
      active2: false,
      active3: false,
      active4: false,
      searchCountry: "",
      items: [],
      invalidBookingId: false,
      invalidPhoneNumber: false,
      booking_id: null,
      // phone_number: null,
      user_number: null,
      verified_movie: null
    };
  },
  beforeMount() {
    this.getItems();
    if (!this.getFndCinema) {
      this.onHandleOpenModal("cinemaModalModal");
    }
    this.getIsUserLogged
      ? (this.user_number = this.getLoggedUser["user_number"])
      : null;
  },
  computed: {
    ...mapGetters(["getIsUserLogged", "getLoggedUser", "getFndCinema"])
  },
  methods: {
    ...mapActions(["onHandleOpenModal"]),
    async getItems() {
      let loader = Vue.$loading.show();
      try {
        const response = await ItemsService.GetItems({});
        const { data } = response;
        if (data && data.status) {
          this.items = data.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        loader.hide();
      }
    },
    async verifyBooking() {
      if (!this.booking_id) {
        this.invalidBookingId = true;
      }
      if (!this.user_number) {
        this.invalidPhoneNumber = true;
      }
      if (this.booking_id && this.user_number) {
        const response = await TransactionService.VerifyBooking({
          booking_id: this.booking_id,
          user_number: this.user_number
        });
        const { data } = response;
        console.log("data.data", data.data);
        if (data && data.status) {
          this.$bvModal.show("verifyBooking");
          this.$bvModal.show("giftSend");
          this.verified_movie = data.data;
        } else if (!data.status) {
          this.invalidBookingId = false;
        }
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/foodAndDrinks.vue